import { styled } from "styled-components";
import { Separator } from "../separator/separator.es.js";
const FILL_CONTAINER_STYLE = {
  flexGrow: 1,
  flexShrink: 1,
  flexBasis: 0
};
const FIT_CONTENT_STYLE = {
  flexGrow: 0,
  flexShrink: 0,
  flexBasis: "auto"
};
const SPACE_VALUE = 8;
const ToolbarGroupImpl = styled("div")(
  {
    display: "flex",
    alignItems: "center",
    minWidth: 0
  },
  {
    // left group
    "&:first-child": {
      ...FILL_CONTAINER_STYLE
    },
    // right group
    "&:first-child + &": {
      justifyContent: "flex-end",
      position: "relative",
      "&::before": {
        content: JSON.stringify(""),
        display: "block",
        position: "absolute",
        top: 0,
        bottom: 0,
        left: -SPACE_VALUE * 2,
        width: SPACE_VALUE * 2,
        maskImage: `linear-gradient(
            to left,
            rgba(0, 0, 0, 1),
            rgba(0, 0, 0, 1),
            rgba(0, 0, 0, 0)
          )`
      }
    }
  }
);
const ToolbarItemImpl = styled("div")(
  {
    whiteSpace: "nowrap",
    minWidth: 0,
    "&:not(:last-child)": {
      paddingRight: SPACE_VALUE
    },
    [`& + ${Separator}`]: {
      paddingLeft: SPACE_VALUE,
      paddingRight: SPACE_VALUE * 2
    }
  },
  ({ $sizing }) => ({
    "fill-container": FILL_CONTAINER_STYLE,
    "fit-content": FIT_CONTENT_STYLE
  })[$sizing],
  ({ $ellipsify }) => $ellipsify === true ? {
    flexShrink: 1,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap"
  } : void 0
);
const ToolbarImpl = styled("div")(
  {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    position: "relative",
    minWidth: 0,
    paddingLeft: SPACE_VALUE * 2,
    [`& > ${ToolbarGroupImpl}, & > ${ToolbarItemImpl}:last-child`]: {
      paddingRight: SPACE_VALUE * 2
    },
    [`& > ${Separator}`]: {
      paddingTop: SPACE_VALUE,
      paddingBottom: SPACE_VALUE
    }
  },
  ({ $variant }) => ({
    primary: {
      height: SPACE_VALUE * 6
    },
    secondary: {
      height: SPACE_VALUE * 5
    },
    inline: {
      height: SPACE_VALUE * 3,
      padding: 0,
      [`& > ${ToolbarGroupImpl},
          & > ${ToolbarItemImpl}:last-child,
          & > ${Separator}`]: {
        padding: 0
      }
    }
  })[$variant],
  ({ $background, theme }) => {
    const backgroundColor = {
      white: theme.color.white10,
      gray: theme.color.monochrome2
    }[$background];
    return {
      backgroundColor,
      [ToolbarGroupImpl]: {
        backgroundColor,
        "&::before": {
          backgroundColor
        }
      }
    };
  }
);
export {
  ToolbarGroupImpl,
  ToolbarImpl,
  ToolbarItemImpl
};
